(function () {
    'use strict';

    function requestForProposalConfig($stateProvider) {
        var offset = 0;
        $stateProvider
            .state('rfp', {
                url: '/rfps/review/:rfpId',
                templateUrl: 'requestForProposal/templates/requestForProposal.html',
                controller: 'requestForProposalController as requestForProposalContainerCtrl',
                resolve: {
                    sessionData: [
                        "sessionDataService", function(sessionDataService) {
                            return sessionDataService.loadSession().then(function(data) {
                                return data;
                            });
                        }
                    ],
                    rfpData: [
                        "$stateParams", "requestForProposalDataService", "requestForProposalStateService",
                        function($stateParams, requestForProposalDataService, requestForProposalStateService) {
                            return requestForProposalDataService.loadRequestForProposal('requestforproposals/' + $stateParams.rfpId).then(function(data) {
                                return requestForProposalStateService.update(data, true);
                            });
                        }
                    ]
                },
                redirectTo: 'rfp.basicInformation'
            })
            .state('rfp.basicInformation', {
                url: '/summary',
                templateUrl: 'requestForProposal/templates/requestForProposalBasicInformation.html',
                controller: 'requestForProposalBasicInformationController as requestForProposalBasicInformationCtrl',
                resolve: {
                    milestones: function () {
                        return ['RequestForProposal'];
                    }
                }
            })
            .state('rfp.content', {
                url: '/content',
                templateUrl: 'requestForProposal/templates/requestForProposalContent.html',
                controller: 'requestForProposalContentController as requestForProposalContentCtrl',
                resolve: {
                    milestones: function () {
                        return ['RequestForProposal', 'RequestForProposalContent'];
                    }
                }
            })
            .state('rfp.findRespondents', {
                url: '/findrespondents',
                templateUrl: 'requestForProposal/templates/requestForProposalFindRespondents.html',
                controller: 'requestForProposalFindRespondentsController as requestForProposalFindRespondentsCtrl',
                resolve: {
                    entitySearchConfiguration: [
                        'rfpData', 'searchConfigurationDataService', function(rfpData, searchConfigurationDataService) {
                            // TODO add the workflow id for owkrflow specific searches
                            return searchConfigurationDataService.loadEntitiesSearch(rfpData.EntitySearchIndex).then(
                                function(data) {
                                    return data;
                                });
                        }
                    ],
                    adminEntitySearchConfiguration: [
                        'rfpData', 'searchConfigurationDataService', function (rfpData, searchConfigurationDataService) {
                            // TODO add the rfp id for rfp specific searches
                            if (rfpData.AdminEntitySearchIndex !== null) {
                                return searchConfigurationDataService.loadEntitiesSearch(rfpData.AdminEntitySearchIndex)
                                    .then(function (data) {
                                        return data;
                                    });
                            }
                            else {
                                return null;
                            }
                        }
                    ],
                    rfpResponses: [
                        'rfpData', 'requestForProposalResponseDataService', function(rfpData, requestForProposalResponseDataService) {
                            return requestForProposalResponseDataService
                                .loadRequestForProposalResponsesForRequestForProposal(rfpData.Id).then(function(data) {
                                    return data;
                                });
                        }
                    ],
                    milestones: function() {
                        return ['RequestForProposal', 'RequestForProposalFindRespondents'];
                    }
                }
            })
            .state('rfp.responseContent', {
                url: '/responsecontent',
                templateUrl: 'requestForProposal/templates/requestForProposalResponseContent.html',
                controller: 'requestForProposalResponseContentController as requestForProposalResponseContentCtrl',
                resolve: {
                    milestones: function () {
                        return ['RequestForProposal', 'RequestForProposalResponseContent'];
                    }
                }
            })
            .state('rfp.responses', {
                url: '/responses',
                templateUrl: 'requestForProposal/templates/requestForProposalResponses.html',
                controller: 'requestForProposalResponsesController as requestForProposalResponsesCtrl',
                resolve: {
                    rfpResponses: [
                        'rfpData', 'requestForProposalResponseDataService', function(rfpData, requestForProposalResponseDataService) {
                            return requestForProposalResponseDataService
                                .loadRequestForProposalResponsesForRequestForProposal(rfpData.Id).then(function(data) {
                                    return data;
                                });
                        }
                    ],
                    milestones: function () {
                        return ['RequestForProposal', 'RequestForProposalResponses'];
                    }
                }
            })
            .state('rfp.responses.single',
            {
                url: '/:rfpResponseId'
            })
            .state('rfp.responses.single.details', {
                url: '/details',
                controller: 'requestForProposalResponsesController as requestForProposalResponsesCtrl',
                onEnter: ['requestForProposalResponseDataService', 'scrollingService', '$stateParams', '$state', '$uibModal', '$timeout',
                function (requestForProposalResponseDataService, scrollingService, $stateParams, $state, $uibModal, $timeout) {
                    $timeout(function() {
                        $uibModal.open({
                            templateUrl: "requestForProposal/templates/requestForProposalSingleResponse.html",
                            size: 'lg',
                            resolve: {
                                rfpResponseData: function() {
                                    return requestForProposalResponseDataService.loadRequestForProposalResponse(
                                        'requestforproposalresponses/' + $stateParams.rfpResponseId).then(function(data) {
                                        return data;
                                    });
                                }
                            },
                            controller: [
                                '$scope', 'rfpResponseData', function($scope, rfpResponseData) {
                                    $scope.rfpResponseData = rfpResponseData;

                                    $scope.dismiss = function() {
                                        $scope.$dismiss();
                                    };

                                    $scope.close = function() {
                                        $scope.$close(true);
                                    };
                                }
                            ]
                        }).result.finally(function () {
                            $state.go('^');
                        });
                    });
                }]
            })
            .state('rfpResponse', {
                url: '/rfpresponses/review/:rfpResponseId',
                templateUrl: 'requestForProposal/templates/requestForProposalResponse.html',
                controller: 'requestForProposalResponseController as requestForProposalResponseContainerCtrl',
                resolve: {
                    sessionData: [
                        "sessionDataService", function (sessionDataService) {
                            return sessionDataService.loadSession().then(function (data) {
                                return data;
                            });
                        }
                    ],
                    rfpResponseData: [
                        "$stateParams", "requestForProposalResponseDataService", "requestForProposalResponseStateService",
                        function ($stateParams, requestForProposalResponseDataService, requestForProposalResponseStateService) {
                            return requestForProposalResponseDataService.loadRequestForProposalResponse(
                                'requestforproposalresponses/' + $stateParams.rfpResponseId).then(function(data) {
                                    return requestForProposalResponseStateService.update(data, true);
                                });
                        }
                    ]
                },
                redirectTo: 'rfpResponse.responseEditor'
            })
            .state('rfpResponse.rfpSummary', {
                url: '/rfpsummary',
                templateUrl: 'requestForProposal/templates/requestForProposalResponseRfpSummary.html',
                controller: 'requestForProposalResponseRfpSummaryController as requestForProposalResponseRfpSummaryCtrl',
                resolve: {
                    milestones: function () {
                        return ['RequestForProposalResponse', 'RequestForProposalResponseRfpSummary'];
                    }
                }
            })
            .state('rfpResponse.responseEditor', {
                url: '/editor',
                templateUrl: 'requestForProposal/templates/requestForProposalResponseEditor.html',
                controller: 'requestForProposalResponseEditorController as requestForProposalResponseEditorCtrl',
                resolve: {
                    milestones: function () {
                        return ['RequestForProposalResponse', 'RequestForProposalResponseEditor'];
                    }
                }
            });
    }

    requestForProposalConfig.$inject = ['$stateProvider'];

    angular.module('ecap.requestForProposal').config(requestForProposalConfig);
})();